import * as angular from 'angular';

angular.module('app.services', []);

require('compartilhado/services/notificacao-stream-service')
require('compartilhado/services/notificacao-service')
require('compartilhado/services/event-service')
require('compartilhado/services/segmentos-api-service')

require('./anexos-api-service')
require('./catalogo-servico-api-service')
require('./categorizacoes-api-service')
require('./chamado-api-service')
require('./chat-service')
require('./colaboradores-api-service')
require('./roteamentos-api-service')
require('./sistema-api-service')


// WEBPACK FOOTER //
// ./src/services/index.js